export default {
  required: '此項為必填',
  email: '請輸入有效的電子郵件',
  phone: '請輸入有效的手機號碼',
  minLength: '最少需要 {min} 個字元',
  maxLength: '最多允許 {max} 個字元',
  number: '請輸入數字',
  integer: '請輸入整數',
  positive: '請輸入正數',
  url: '請輸入有效的網址',
  passwordMismatch: '兩次輸入的密碼不一致',
  passwordWeak: '密碼強度不足',
};
